module.exports = __webpack_public_path__ + "img/03-title-babo.b5818f7f.png";